import { z } from "zod";

/**
 * Our value translated into what a Dynamics field accepts (PREC-4363): a gender to a salutation
 * option or word, later a country or state to an option, a lookup record or a name.
 */
export const MsdynamicsValueMapEntrySchema = z.object({
	sourceKey: z.string(),
	targetValue: z.string(),
	targetLabel: z.string().nullish(),
	resolvedBy: z.string(),
});

export type MsdynamicsValueMapEntry = z.infer<typeof MsdynamicsValueMapEntrySchema>;

export const MsdynamicsValueMapSchema = z.object({
	kind: z.enum(["GENDER", "COUNTRY", "STATE", "SENTIMENT", "CHANNEL", "CAMPAIGN_STATE"]),
	target: z.enum(["PICKLIST", "TEXT", "LOOKUP"]),
	entries: z.array(MsdynamicsValueMapEntrySchema),
	unplaced: z.array(z.object({ value: z.string(), label: z.string() })).nullish(),
	language: z.string().nullish(),
	format: z.enum(["EN_NAME", "DE_NAME", "ISO2", "ISO3", "CODE", "ISO"]).nullish(),
	lookup: z.object({ entitySetName: z.string(), navigationProperty: z.string() }).nullish(),
	resolvedAt: z.string(),
});

export type MsdynamicsValueMap = z.infer<typeof MsdynamicsValueMapSchema>;
